export default __webpack_public_path__ + "assets/images/icon-copy.c4fafb7d8526fc7c096d3bf108886404.svg";